import React from 'react'
import {
  BankFilled,
  // CarryOutFilled,
  BookFilled,
  ContactsFilled,
  SettingFilled,
  // ApiOutlined,
  AreaChartOutlined,
  ContainerOutlined,
  ShoppingCartOutlined,
  FundOutlined,
} from '@ant-design/icons'
import config from 'configs/config'

const {
  roles: { donor, subscriber },
  actions: { read, edit, anything },
  components: {
    fundraiser,
    program,
    service,
    auction,
    rental,
    marketplace,
    organizationDashboard,
    organizationDetails,
    organizationSubscription,
    organizationPayment,
    organizationReport,
    organizationBusinessRequests,
    organizationB2BProgram,
    organizationCommunity,
    volunteer,
  },
  organizationAdmin,
} = config

const menuItems = {
  items: [
    {
      id: 'sidebar-title-items',
      title: '',
      // title: 'Pages',
      type: 'group',
      children: [
        {
          id: 'sidebar-title-auction',
          title: 'Auctions',
          type: 'item',
          icon: (isSelected, color) => (
            <ShoppingCartOutlined
              className="icon "
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          url: '/auction',
          roles: [donor],
          action: read,
          on: auction,
        },
        // {
        //   id: 'sidebar-title-campaigns',
        //   title: 'Campaigns',
        //   type: 'item',
        //   icon: (isSelected, color) => (
        //     <ApiOutlined
        //       className="icon "
        //       style={{
        //         background: isSelected ? color : '',
        //       }}
        //     />
        //   ),
        //   url: '/campaigns',
        //   roles: [donor],
        //   action: read,
        //   on: fundraiser,
        // },
        // {
        //   id: 'sidebar-title-events',
        //   title: 'Events',
        //   type: 'item',
        //   icon: (isSelected, color) => (
        //     <CarryOutFilled
        //       className="icon "
        //       style={{
        //         background: isSelected ? color : '',
        //       }}
        //     />
        //   ),
        //   url: '/events',
        //   roles: [donor],
        //   action: read,
        //   on: fundraiser,
        // },
        {
          id: 'sidebar-title-fundraisers',
          title: 'Fundraisers',
          type: 'item',
          icon: (isSelected, color) => (
            <FundOutlined
              className="icon "
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          url: '/fundraisers',
          roles: [donor],
          action: read,
          on: fundraiser,
        },
        {
          id: 'sidebar-title-businesses',
          title: 'Marketplace',
          type: 'item',
          icon: (isSelected, color) => (
            <BankFilled
              className="icon"
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          url: '/businesses',
          roles: [donor],
          action: read,
          on: marketplace,
        },
        {
          id: 'sidebar-title-programs',
          title: 'Programs',
          type: 'item',
          icon: (isSelected, color) => (
            <BookFilled
              className="icon "
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          url: '/programs',
          roles: [donor],
          action: read,
          on: program,
        },
        {
          id: 'sidebar-title-room',
          title: 'Rentals',
          type: 'item',
          icon: (isSelected, color) => (
            <ContainerOutlined
              className="icon "
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          url: '/rentals',
          roles: [donor],
          action: read,
          on: rental,
        },
        {
          id: 'sidebar-title-services',
          title: 'Services',
          type: 'item',
          icon: (isSelected, color) => (
            <AreaChartOutlined
              className="icon "
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          url: '/services',
          roles: [donor],
          action: read,
          on: service,
        },
        // {
        //   id: 'sidebar-title-volunteer',
        //   title: 'Volunteer Opps',
        //   type: 'item',
        //   icon: (isSelected, color) => (
        //     <ContactsFilled
        //       className="icon "
        //       style={{
        //         background: isSelected ? color : '',
        //       }}
        //     />
        //   ),
        //   url: '/volunteer',
        //   roles: [config.roles.subscriber],
        // },
        {
          id: 'sidebar-title-volunteer-opportunities',
          title: 'Volunteer Opps',
          type: 'item',
          icon: (isSelected, color) => (
            <ContactsFilled
              className="icon "
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          url: '/volunteer-opportunities',
          roles: [donor],
          action: read,
          on: volunteer,
        },
        // {
        //   id: 'sidebar-title-report',
        //   title: 'Reports',
        //   type: 'item',
        //   icon: (isSelected, color) => (
        //     <BarChartOutlined
        //       className="icon "
        //       style={{
        //         background: isSelected ? color : '',
        //       }}
        //     />
        //   ),
        //   url: '/reports',
        //   roles: [
        //     // config.roles.admin,
        //     // config.roles.donor,
        //     config.roles.subscriber,
        //   ],
        // },
      ],
    },
    {
      id: 'sidebar-title-groups',
      title: 'Groups',
      className: 'd-none',
      type: 'group',
      children: [
        {
          id: 'admin',
          title: <span className="label">Admin</span>,
          type: 'collapse',
          icon: (isSelected, color) => (
            <SettingFilled
              className="icon"
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          children: [
            {
              id: 'sidebar-title-organizations',
              title: 'Organizations',
              type: 'item',
              url: '/organizations',
              roles: [config.roles.admin],
            },
            {
              id: 'sidebar-title-hardware',
              title: 'Hardware',
              type: 'item',
              url: '/hardware',
              roles: [config.roles.admin],
            },
            {
              id: 'sidebar-subtitle-manage-gov-issued-docs',
              title: 'Manage Gov Docs',
              type: 'item',
              url: '/settings/manage-gov-issued-docs',
              roles: [config.roles.admin],
            },
            {
              id: 'sidebar-subtitle-manage-feedbacks',
              title: 'Community Feedback',
              type: 'item',
              url: '/settings/manage-feedbacks',
              roles: [config.roles.admin],
            },
            {
              id: 'sidebar-subtitle-manage-rental-facilities',
              title: 'Rental Request',
              type: 'item',
              url: '/settings/manage-reservations-requests',
              roles: [config.roles.admin],
            },
          ],
          roles: [config.roles.admin],
        },
        {
          id: 'Organization',
          title: <span className="label">My Organization</span>,
          type: 'collapse',
          icon: (isSelected, color) => (
            <SettingFilled
              className="icon"
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          children: [
            {
              id: 'sidebar-subtitle-organization-home',
              title: 'Dashboard',
              type: 'item',
              url: '/home',
              roles: [donor, subscriber],
              action: read,
              on: organizationDashboard,
            },
            {
              id: 'sidebar-subtitle-organization-new-detail',
              title: 'New Org Details',
              type: 'item',
              url: '/settings/manage-organization/organization-detail',
              roles: [donor, subscriber],
              action: read,
              on: organizationDetails,
            },
            {
              id: 'sidebar-subtitle-organization-detail',
              title: 'Legacy Settings',
              type: 'item',
              url: '/settings/register-organization',
              roles: [donor, subscriber],
              action: edit,
              on: organizationDetails,
            },
            {
              id: 'sidebar-subtitle-subscription-details',
              title: 'Subscription Details',
              type: 'item',
              url: '/settings/billing',
              roles: [donor, subscriber],
              action: read,
              on: organizationSubscription,
            },
            {
              id: 'sidebar-subtitle-manage-payments-accounts',
              title: 'Payments',
              type: 'item',
              url: '/settings/manage-payments-accounts',
              roles: [donor, subscriber],
              action: read,
              on: organizationPayment,
            },
            {
              id: 'sidebar-subtitle-manage-roles',
              title: 'Assign Roles',
              type: 'item',
              url: '/settings/organization/manage-roles',
              roles: [subscriber],
              action: read,
              on: organizationAdmin,
            },
            {
              id: 'sidebar-subtitle-manage-report',
              title: 'Reports',
              type: 'item',
              url: '/reports',
              roles: [donor, subscriber],
              action: read,
              on: organizationReport,
            },
            {
              id: 'sidebar-subtitle-manage-association-requests',
              title: 'Business Requests',
              type: 'item',
              url: '/settings/manage-organization/listing-requests',
              roles: [donor, subscriber],
              action: read,
              on: organizationBusinessRequests,
            },
            {
              id: 'sidebar-subtitle-manage-businesses-configuration',
              title: 'B2B Program',
              type: 'item',
              url: '/settings/manage-organization/my-businesses-configuration',
              roles: [donor, subscriber],
              action: read,
              on: organizationB2BProgram,
            },
            // {
            //   id: 'sidebar-subtitle-manage-businesses-configuration',
            //   title: 'B2B Program (New)',
            //   type: 'item',
            //   url: '/settings/manage-organization/my-businesses-configurationv2',
            //   roles: [config.roles.subscriber],
            // },
            {
              id: 'sidebar-subtitle-manage-my-community',
              title: 'Community',
              type: 'item',
              url: '/settings/manage-organization/my-community',
              roles: [donor, subscriber],
              action: read,
              on: organizationCommunity,
            },
            {
              id: 'sidebar-subtitle-manage-volunteer-list',
              title: 'Volunteer',
              type: 'item',
              url: '/settings/manage-organization/volunteer-communities',
              roles: [config.roles.subscriber],
            },
            // {
            //   id: 'sidebar-subtitle-manage-my-reports',
            //   title: 'My Reports',
            //   type: 'item',
            //   url: '/settings/manage-organization/my-reports',
            // },
            // {
            //   id: 'sidebar-subtitle-manage-my-events',
            //   title: 'Event Presenters',
            //   type: 'item',
            //   url: '/settings/manage-organization/my-events',
            //   roles: [config.roles.subscriber],
            // },
          ],
          roles: [donor, subscriber],
          action: anything,
          on: 'organizationComponents',
        },
        {
          id: 'account',
          title: <span className="label">My Stuff</span>,
          type: 'collapse',
          icon: (isSelected, color) => (
            <SettingFilled
              className="icon"
              style={{
                background: isSelected ? color : '',
              }}
            />
          ),
          children: [
            {
              id: 'sidebar-subtitle-register-organization',
              title: 'Register Organization',
              type: 'item',
              url: '/settings/register-organization-v2',
              roles: [config.roles.donor],
            },
            {
              id: 'sidebar-subtitle-my-account',
              title: 'My Account',
              type: 'item',
              url: '/settings/account',
              roles: [config.roles.donor],
            },
            {
              id: 'sidebar-subtitle-my-invites',
              title: 'Requests',
              type: 'item',
              url: '/settings/invites',
              roles: [config.roles.donor],
            },
            {
              id: 'sidebar-subtitle-manage-business',
              title: 'My Business',
              type: 'collapse',
              roles: [config.roles.business],
              children: [
                {
                  id: 'sidebar-subtitle-business-detail',
                  title: 'Business Detail',
                  type: 'item',
                  url: '/settings/manage-organization/business-detail',
                },
                {
                  id: 'sidebar-subtitle-my-business-service-requests',
                  title: 'Service Requests',
                  type: 'item',
                  url: '/settings/manage-organization/my-business-service-requests',
                },
                {
                  id: 'sidebar-subtitle-my-business-customers',
                  title: 'My Customers',
                  type: 'item',
                  url: '/settings/manage-organization/manage-business-customers',
                },
                {
                  id: 'sidebar-subtitle-my-business-earnings',
                  title: 'My Revenue',
                  type: 'item',
                  url: '/settings/manage-organization/manage-business-earnings',
                },
                {
                  id: 'sidebar-subtitle-my-business-manage-payments-accounts',
                  title: 'Business payments',
                  type: 'item',
                  url: '/settings/manage-organization/manage-payments-accounts',
                },
              ],
            },
            {
              id: 'sidebar-subtitle-logout',
              title: 'Logout',
              type: 'item',
              button: true,
              url: '/',
              roles: [
                config.roles.admin,
                config.roles.donor,
                config.roles.presenter,
                config.roles.subscriber,
              ],
            },
          ],
          roles: [config.roles.donor],
        },
      ],
    },
  ],
}

export { menuItems }
